<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping 3D Data</span>
                </div>
            </div>
        </header>
        <!-- // header -->
        <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
        <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />

        <div id="content-wrap">
            <div id="contents">
                <!-- data-info-wrapper -->
                <div class="data-info-wrapper">
                    <div class="container">
                        <ul>
                            <li :class="pageIdx === 1 ? 'on' : ''">
                                <a @click="setPageIndex(1)"><span>단면사진보기</span></a>
                            </li>
                            <li :class="pageIdx === 3 ? 'on' : ''">
                                <a @click="setPageIndex(3)"><span>3D보기</span></a>
                            </li>
                        </ul>
                        <div class="btn-wrapper">
                            <button class="btn btn-confirm" @click="etcImageSetting()">
                                <span>도면이미지 보기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- // data-info-wrapper -->

            <div class="deep-viewer-wrapper" :class="navClose">
                <!-- sidenav -->
                <div class="sidenav-wrapper">
                    <div class="sidebox-select">
                        <div class="select-box">
                            <select v-model="selectConstructionName" @change="dataObj(selectConstructionName)">
                                <option
                                    v-for="(item, index) in constructionNameCodeList"
                                    :key="index"
                                    :value="item.code"
                                >
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="sidebox">
                        <ul v-for="(item, index) in measureLocationCodeList" :key="index" :value="item.code">
                            <li>
                                <a class="folder">{{ item.name }}</a>
                                <ul>
                                    <li>
                                        <a class="folder">STA</a>
                                        <ul v-for="(data, key) in datas" :key="key" :value="data.code">
                                            <li
                                                v-if="
                                                    data.measureLocation === item.code &&
                                                        data.constructionCode == selectConstructionName
                                                "
                                                :class="data.id === selectedId ? 'on' : ''"
                                                @click="selectStation(data.id, data.constructionCode, data.station)"
                                            >
                                                <a class="file">{{ data.station }}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <button
                        type="button"
                        class="btn nav-close"
                        @click="navCloseBtn(navClose == 'subnav-side-hide' ? '' : 'subnav-side-hide')"
                    >
                        <span class="blind">닫기</span>
                    </button>
                </div>
                <!-- // sidenav -->

                <!-- right-image-box -->
                <div v-show="pageIdx === 1" class="right-image-box">
                    <div class="list-3d-wrapper">
                        <div v-for="(data, index) in imgDatas" :key="index" class="item-3d">
                            <div class="item-header">
                                {{ data.station }}
                            </div>
                            <div class="item-body" @click="selectStation(data.id, data.constructionCode)">
                                <div class="image-box image-box-1">
                                    <img :src="data.threeDimensionalImageUrl" alt="3D이미지" @error="imgError" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <pagination :page-param="pageParam" @pageCallback="pageCallback" />
                </div>
                <!-- // right-image-box -->

                <!-- right-image-box -->
                <div v-show="pageIdx === 2" class="right-image-box">
                    <div class="image-box image-box-2">
                        <img v-gallery :src="etcImage1" alt="etcImage" @error="imgError" />
                    </div>
                    <div class="image-box image-box-2">
                        <img v-gallery :src="etcImage2" alt="etcImage" @error="imgError" />
                    </div>
                    <div class="image-box image-box-2">
                        <img v-gallery :src="etcImage3" alt="etcImage" @error="imgError" />
                    </div>
                </div>
                <!-- // right-image-box -->
                <!-- right-image-box -->
                <div v-show="pageIdx === 3" class="right-image-box">
                    <div id="data-3d" class="image-box image-box-3" style="padding-bottom: 0%;">
                        <div id="unity-container" class="unity-mobile">
                            <canvas id="unity-canvas" />
                            <div id="unity-loading-bar">
                                <div id="unity-logo" />
                                <div id="unity-progress-bar-empty">
                                    <div id="unity-progress-bar-full" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- // right-image-box -->
            </div>
        </div>
    </body>
</template>

<script>
import { mapActions, mapState } from 'vuex';
//import MutationTypes from '../store/MutationTypes';
import CodeApi from '../api/CodeApi';
import FacemappingApi from '../api/FacemappingApi';
import {
    AUTH,
    COMM_CODE,
    CONSTRUCTION,
    CONSTRUCTION_NM,
    FILE_URL,
    NO_IMG,
    PAGINATION,
    TD_IMG,
    TD_IMG_URL,
    TYPE
} from '../const';
import pagination from './common/pagination.vue';
import gnb from './layout/gnb.vue';

export default {
    name: 'ThreeDimensional',
    components: {
        gnb,
        pagination
    },
    data: () => {
        return {
            datas: {},
            imgDatas: {},
            param: {
                page: PAGINATION.number,
                rows: PAGINATION.td_numberOfElements,
                threeDimensional: 'Y',
                constructionName: ''
            },
            pageParam: {
                curPage: PAGINATION.number,
                totalCnt: PAGINATION.totalPages,
                lstCnt: PAGINATION.td_numberOfElements,
                pageCnt: PAGINATION.size
            },
            gnbShow: '',
            navClose: '',
            constructionNameCodeList: [],
            measureLocationCodeList: [],
            selectConstructionName: '',
            etcImage1: '',
            etcImage2: '',
            etcImage3: '',
            fileUrl: FILE_URL,
            tdImg1: TD_IMG.plane,
            tdImg2: TD_IMG.verticalPlane,
            tdImg3: TD_IMG.section,
            pageIdx: 1,
            selectedId: '',
            container: null,
            camera: null,
            controls: null,
            scene: null,
            renderer: null,
            ambient: null,
            background_color: 0xf5f5f1,
            unityInstance: null
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {
        this.hideLoading();
        //ScreenHelper.setLandscape();

        if (localStorage.getItem(TYPE) === AUTH.admin) {
            this.constructionNameSettign(COMM_CODE.constructionName);
        } else {
            this.constructionNameCodeList.push({
                name: localStorage.getItem(CONSTRUCTION_NM),
                code: localStorage.getItem(CONSTRUCTION)
            });
            this.selectConstructionName = localStorage.getItem(CONSTRUCTION);
            this.dataObj(this.selectConstructionName);
        }
        this.measureLocationSetting(COMM_CODE.measureLocation);
        this.init3D();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        imgError(e) {
            e.target.src = NO_IMG;
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        backbtn() {
            this.$router.go(-1);
        },
        navCloseBtn(status) {
            this.navClose = status;
        },
        constructionNameSettign(code) {
            CodeApi.subCodeList(code, 2).then(res => {
                this.constructionNameCodeList = res.content;
                this.selectConstructionName = res.content[0].code;
                this.preDataObj(this.selectConstructionName);
            });
        },
        preDataObj(constructionName) {
            this.dataObj(constructionName);
        },
        dataObj(constructionName) {
            this.param.constructionName = constructionName;
            this.resetPage();

            var param = {};
            param.constructionName = constructionName;
            FacemappingApi.getThreeDimensionalList(param).then(res => {
                this.datas = res.content;
                this.list();
            });
        },
        resetPage() {
            this.pageParam.curPage = PAGINATION.number;
            this.pageParam.totalCnt = PAGINATION.totalPages;
            this.pageParam.lstCnt = PAGINATION.td_numberOfElements;
            this.pageParam.pageCnt = PAGINATION.size;

            this.param.page = PAGINATION.number;
            this.param.rows = PAGINATION.td_numberOfElements;
        },
        measureLocationSetting(code) {
            CodeApi.subCodeList(code, 2).then(res => {
                this.measureLocationCodeList = res.content;
            });
        },
        setPageIndex(idx) {
            this.pageIdx = idx;
            this.selectedId = '';
        },
        etcImageSetting() {
            //$('#data-3d').html('');
            console.log(TD_IMG_URL);
            this.pageIdx = 2;
            this.selectedId = '';
            /*
            this.etcImage1 = TD_IMG_URL + this.selectConstructionName + '/' + this.tdImg1;
            this.etcImage2 = TD_IMG_URL + this.selectConstructionName + '/' + this.tdImg2;
            this.etcImage3 = TD_IMG_URL + this.selectConstructionName + '/' + this.tdImg3;
            */
            this.etcImage1 = '/api/file/download/image?file_id=999999999&file_no=1';
            this.etcImage2 = '/api/file/download/image?file_id=999999999&file_no=2';
            this.etcImage3 = '/api/file/download/image?file_id=999999999&file_no=3';
        },
        pageCallback(page) {
            this.param.page = page;
            this.list();
        },
        list() {
            this.showLoading();
            FacemappingApi.list(this.param).then(res => {
                this.imgDatas = res.content;
                this.pageParam.totalCnt = res.pageable.total;
                this.pageParam.curPage = res.pageable.page + 1;
                this.hideLoading();
            });
        },
        selectStation(id, constructionCode, station) {
            this.selectedId = id;
            if (this.pageIdx === 3) {
                if (station) {
                    var staMeter = this.parseStationNumber(station);
                    var jsonData = {
                        listFocus: [{ sendFocusLoc: staMeter, sendFocusId: id }]
                    };
                    this.unityInstance.SendMessage('createObject', 'SendFocusData', JSON.stringify(jsonData));

                    return;
                }

                //this.unityInstance.SendMessage('createObject', 'sendId', id);
            }
            this.$router.push({ path: `/detail/${constructionCode}/${id}` });
        },
        init3D() {
            var canvas = document.querySelector('#unity-canvas');
            var loadingBar = document.querySelector('#unity-loading-bar');
            var progressBarFull = document.querySelector('#unity-progress-bar-full');

            var buildUrl = '/3d';
            //var loaderUrl = buildUrl + '/juwangDam_240617.loader.js';
            var config = {
                dataUrl: buildUrl + '/juwangDam_V2.data',
                frameworkUrl: buildUrl + '/juwangDam_V2.framework.js',
                codeUrl: buildUrl + '/juwangDam_V2.wasm',
                companyName: 'DefaultCompany',
                productName: 'DFMS_OSM_240304',
                productVersion: '0.1'
            };

            window
                .createUnityInstance(canvas, config, progress => {
                    progressBarFull.style.width = 100 * progress + '%';
                })
                .then(instance => {
                    loadingBar.style.display = 'none';
                    this.unityInstance = instance;
                    this.loadUnitData();
                })
                .catch(message => {
                    alert(message);
                });
        },
        loadUnitData() {
            var params = {};
            params.page = 1;
            params.rows = 100;
            params.threeDimensional = 'Y';
            params.constructionName = this.selectConstructionName;

            //추후 이 부분을 interval 등을 이용하여 가여오는 주기를 수정한다.
            //var unitData = [];
            FacemappingApi.list(params).then(response => {
                const unitData = response.content.map(item => {
                    return {
                        sendUrl: item.threeDimensionalImageUrl,
                        sendLoc: this.parseStationNumber(item.station),
                        sendDate: item.regDay,
                        sendId: item.id,
                        sendDigtype: 1
                    };
                });
                console.log(unitData);
                this.unityInstance.SendMessage('createObject', 'sendAllData', JSON.stringify({ list: unitData }));
            });

            /*
            FacemappingApi.list(params, function(response) {
                console.log(response);
                $.each(response.content, function() {
                    var data = {
                        sendUrl: this.threeDimensionalImageUrl,
                        sendLoc: this.parseStationNumber(this.station),
                        sendDate: this.regDay,
                        sendId: this.id,
                        sendDigtype: 1
                    };
                    unitData.push(data);
                });

                console.log(unitData);
                this.unityInstance.SendMessage('createObject', 'sendAllData', JSON.stringify({ list: unitData }));
            });
            */
        },
        parseStationNumber(staString) {
            // 정규 표현식으로 "STA NO." 부분을 무시하고 km와 미터 값을 추출합니다.
            // `\+`를 포함하거나 포함하지 않는 경우 모두 고려합니다.
            const regex = /STA NO\.?\s*(\d*)(\+)?(\d+\.?\d*)/i;
            const match = staString.match(regex);

            if (match) {
                // km 부분이 비어 있으면 0으로 간주합니다.
                const km = parseInt(match[1], 10) || 0;
                const meters = parseFloat(match[3]);

                // 전체 미터 계산: km * 1000 + meters
                const totalMeters = km * 1000 + meters;
                return totalMeters;
            } else {
                // 정확한 오류 메시지를 위해 입력된 문자열을 함께 출력합니다.
                throw new Error(`Invalid STA NO. format: ${staString}`);
            }
        }
    }
};
</script>
<style type="text/css">
#unity-container {
    margin: 0;
    padding: 0;
    width: 100%;
    height: calc(100vh - 200px);
    overflow: hidden;
}

#unity-canvas {
    /* Make the canvas fill the screen */
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    margin: 5px;
}
</style>
